export const activeStatuses = ['Active', 'RejectedEdit', 'PendingApprovalEdit']
export const inactiveStatuses = ['PendingApprovalNew', 'RejectedNew']
